import { ForgottenPassword } from '../../components/landing/ForgottenPassword';

export function ForgottenPasswordPage() {
  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-900 dark:to-black">
      <ForgottenPassword />
    </div>
  );
}
